import React, { useEffect, useRef, useState } from "react";
import SelectFromLibr from "./SelectFromLibr";
import DefaultQuestion from "./DefaultQuestion";
import QuestionListAssessment from "./QuestionListAssessment";
import axios from "../../axios";
import { useSelector } from "react-redux";
import ProgressBar from "../../Helper/ProgressBar";
import SourceLibrary from "../../Enum/SourceLibraryEnum";
import OperationType from "../../Enum/OperationTypeEnum";
import { useNavigate } from "react-router-dom";
import ComponentType from "../../Enum/ComponentTypeEnum";
import PublishPreviewQB from "./PublishPreviewQB";
import FailedApiErrorPopup from "./FailedApiErrorPopup";
import CheckDuplicatePop from "./CheckDuplicatePop";
import RightDrawer from "./rightDrawer";
import QuestionPaperMapper from "./QuestionPaperMaper";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { hasFeature } from "../../Utils/features";
import AiGenerateQuestions from "./AiGenerateQuestions";
import { toast } from "react-toastify";
import { Tooltip } from "@mui/material";

const UpdateQuestions = ({
  operationType,
  componentType,
  setClickFromCreate,
  assessmentDetails,
  setAssessmentDetails,
  questions,
  setQuestions,
  addMoreQuestion,
  checkAllDataField,
  findTotalMarks,
  handleCreateAssessment,
  isloading,
  showErrorInputField,
  setShowErrorInputField,
  getErrorMsg,
  isChecked,
  setIsChecked,
  isCheckAdaptiveAdd,
  openPopup,
  setOpenPopup,
  findDuplicateQuestions,
  handleAdaptiveQuesType,
  viewErrorMsg,
  hidePopupCheck,
  setOpenPopupDupli,
  openPopupDupli,
  isSetOpenPopupDupli,
  isopenPopupDupli,
  selectedBox,
  copyPrevSettings,
  setCopyPrevSettings,
}) => {
  const [questionTypeData, setQuestionTypeData] = useState([]);
  const [difficultyLevel, setDifficultyLevel] = useState([]);
  const [sourceLibrary, setSourceLibrary] = useState(null);
  const [questionData, setquestionData] = useState([]);
  const [open, setOpen] = useState(false);
  const [newQuestionPaperMaper, setNewQuestionPaperMaper] = useState(false);
  const domainsData = useSelector((state) => state.initialData.domain);
  const [searchTerm, setSearchTerm] = useState("");
  const questionRefs = useRef({});
  const scrollContainerRef = useRef(null);

  const navigate = useNavigate();
  const {
    standard_id,
    subject_id,
    section_id,
    total_duration,
    name,
    description,
  } = assessmentDetails;

  const [click, setClick] = useState(false);
  const [click1, setClick1] = useState(false);
  const [isInProgress, setIsInProgress] = useState(false);
  const skillsData = useSelector((state) => state.initialData.skills);
  const [questionType, setQuestionType] = useState([]);
  const [openQuestionBox, setOpenQuestionBox] = useState(false);
  const [activeQuestion, setActiveQuestion] = useState(null);
  const difficulty_levelData = useSelector(
    (state) => state.initialData.difficultyLevels,
  );
  const [dropdownList, setDropdownList] = useState({
    skills: skillsData,
    types: questionType,
    domains: null,
    chapters: null,
    difficultyLevels: difficulty_levelData,
  });
  const { skills, types, domains, chapters, difficultyLevels } = dropdownList;

  const [questionScoreCounter, setQuestionScoreCounter] = useState({
    skills: [],
    questionType: [],
    difficultyLevel: [],
  });

  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );

  // ─── Max Marks Validation for Next ──────────
  const maxMarks = Number(assessmentDetails?.total_marks) || 0;
  const totalMarks = findTotalMarks() || 0;
  const marksDiff = totalMarks - maxMarks;
  const isMarksMismatch = maxMarks > 0 && totalMarks !== maxMarks;

  const getDetails = async () => {
    try {
      let chapters = await axios.get(
        `/api/v1/cm/library/book/getBookByClassSectionSubject?standard_id=${assessmentDetails?.standard_id?.id}&section_id=${assessmentDetails?.section_id?.id}&subject_id=${assessmentDetails?.subject_id?.id}&timetableSessionId=${timeTableSessionId}`,
      );
      chapters &&
        setDropdownList((prev) => ({ ...prev, chapters: chapters.data.data }));
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (
      assessmentDetails?.standard_id?.id &&
      assessmentDetails?.section_id?.id &&
      assessmentDetails?.subject_id?.id &&
      timeTableSessionId
    ) {
      getDetails();
    }
  }, [
    assessmentDetails?.standard_id?.id,
    assessmentDetails?.section_id?.id,
    assessmentDetails?.subject_id?.id,
    timeTableSessionId,
  ]);

  useEffect(() => {
    setDropdownList((prev) => ({ ...prev, skills: skillsData }));
    setDropdownList((prev) => ({ ...prev, types: questionType }));
    setDropdownList((prev) => ({ ...prev, domains: domainsData }));
    setDropdownList((prev) => ({
      ...prev,
      difficultyLevels: difficulty_levelData,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skills, types, domains, difficultyLevels, questionType]);

  const school_id = JSON.parse(localStorage.getItem("schoolId"));

  const checkQuestionTypes = async () => {
    try {
      const res = await axios.get(
        `/api/v1/questionType/get/school/${school_id}`,
      );

      if (res.data.data.length > 0) setQuestionType(res.data.data);
    } catch (error) {
      console.log(error, "error while fetching quwstion type");
    }
  };

  useEffect(() => {
    checkQuestionTypes();
  }, [school_id]);

  useEffect(() => {
    setInitialDataInCounter();
    questions.map((item, index) => {
      const correctScore = Number(item.correct_score);
      if (item.skill_id !== null) {
        setQuestionScoreCounter((prev) => {
          let current = prev.skills.map((val, i) => {
            if (val.id == item.skill_id) {
              val["value"] += correctScore;
            }
            return val;
          });
          return {
            ...prev,
            skills: current,
          };
        });
      }
      if (item.question_type !== null) {
        setQuestionScoreCounter((prev) => {
          let current = prev.questionType.map((val, i) => {
            if (val.id == item.type_id) {
              val["value"] += correctScore;
            }
            return val;
          });
          return {
            ...prev,
            questionType: current,
          };
        });
      }
      if (item.difficulty_level !== null) {
        setQuestionScoreCounter((prev) => {
          let current = prev.difficultyLevel.map((val, i) => {
            if (val.id == item.difficulty_level) {
              val["value"] += correctScore;
            }
            return val;
          });
          return {
            ...prev,
            difficultyLevel: current,
          };
        });
      }
    });
  }, [questions]);

  const setInitialDataInCounter = () => {
    let skills = [];
    skillsData.map((skill) => {
      skills.push({
        value: 0,
        label: skill.name,
        id: skill.id,
      });
    });
    setQuestionScoreCounter((prev) => {
      return {
        ...prev,
        skills: skills,
      };
    });
    let qType = [];
    questionType.map((type) => {
      qType.push({
        value: 0,
        label: type.name,
        id: type.id,
      });
    });
    setQuestionScoreCounter((prev) => {
      return {
        ...prev,
        questionType: qType,
      };
    });
    setQuestionTypeData(qType);

    let dLevel = [];
    difficulty_levelData.map((level, i) => {
      dLevel.push({
        value: 0,
        label: level.name,
        id: level.id,
      });
    });
    setQuestionScoreCounter((prev) => {
      return {
        ...prev,
        difficultyLevel: dLevel,
      };
    });
    setDifficultyLevel(dLevel);
  };
  useEffect(() => {
    setInitialDataInCounter();
  }, []);

  const getquestiondata = (data) => {
    setquestionData(data);
  };

  function shortenParagraph(text, maxLength) {
    if (text?.length <= maxLength) {
      return text;
    }
    return text?.slice(0, maxLength).trim() + "...";
  }

  const skillToDomainNameMap = {
    Remember: "Factual",
    Understand: "Conceptual",
    Apply: "Conceptual",
    Analyze: "Procedural",
    Evaluate: "Metacognitive",
    Create: "Metacognitive",
    None: "None",
  };

  const domainNameToIdMap = Object.fromEntries(
    Array.isArray(domains) ? domains.map((d) => [d.name, d.id]) : [],
  );

  const skillsWithDomainId =
    Array.isArray(skills) &&
    skills.map((skill) => {
      const domainName = skillToDomainNameMap[skill.name];
      const domainId = domainNameToIdMap[domainName] || null;

      return {
        ...skill,
        domain_id: domainId,
      };
    });

  // SAME DATA jo dropdown use karta hai
  const noneSkill = skillsWithDomainId?.find((skill) => skill.name === "None");
  const noneDifficulty = difficultyLevel?.find((d) => d.label === "None");

  const getBaseQuestionTemplate = () => ({
    standard_id: standard_id ? standard_id.id : null,
    subject_id: subject_id ? subject_id.id : null,
    section_id: section_id ? section_id.id : null,
    book_id: null,
    chapter_id: null,
    question_type: null,
    type_id: null,
    domain_id: null,
    skill_id: null,
    difficulty_level: null,
    title: null,
    correct_score: null,
    is_mandatory: false,
    add_to: null,
    add_to_mock: false,
    attachments: [],
    options: [],
    correct_answers: [],
  });

  const handleMapperSave = (mapperQuestions) => {
    const othersBook = chapters
      ?.flatMap((section) => section.bookInfo || [])
      ?.find((book) => book?.name?.toLowerCase() === "others");

    const othersChapter = chapters
      ?.flatMap((section) => section.bookInfo || [])
      ?.flatMap((book) => book.chapterData || [])
      ?.find((chapter) => chapter?.chapterName?.toLowerCase() === "others");

    setQuestions((prev) => {
      const updated = [...prev];

      mapperQuestions.forEach((mq) => {
        const base = getBaseQuestionTemplate();
        const selectedType = types.find((t) => t.id === mq.type_id);

        let question = {
          ...base,

          title: mq.title,
          correct_score: mq.correct_score,

          // ✅ DEFAULTS
          skill_id: noneSkill?.id ?? null,
          domain_id: noneSkill?.domain_id ?? null,
          difficulty_level: noneDifficulty?.id ?? null,

          // ✅ BOOK & CHAPTER → OTHERS (INDEX-FREE)
          book_id: othersBook?.id ?? null,
          chapter_id: othersChapter?.id ?? null,

          type_id: mq.type_id,
          question_type: String(selectedType?.is_manually_graded),
          attachments: Array.isArray(mq.attachments)
            ? mq.attachments.map((att) =>
                typeof att === "string" ? att : att.url,
              )
            : [],
        };

        // 🔹 MCQ
        if (selectedType?.is_manually_graded === false) {
          question.options = Array.from(
            { length: mq.mcqOptionsCount },
            (_, i) => ({
              key: String.fromCharCode(65 + i),
              value: `Option ${String.fromCharCode(65 + i)}`,
            }),
          );

          question.correct_answers = [
            {
              option_key: mq.correct_answer ?? null,
              value:
                mq.correct_answer != null
                  ? `Option ${mq.correct_answer}`
                  : null,
              reason_for_answer: {
                explanation: mq.teacher_note ?? null,
                attachments: null,
              },
            },
          ];
        } else {
          question.options = [];
          question.correct_answers = [
            {
              value: null,
              reason_for_answer: {
                explanation: mq.teacher_note ?? null,
                attachments: null,
              },
            },
          ];
        }

        updated.push(question);
      });

      return updated;
    });
  };

  const isAdaptiveCase =
    selectedBox === "adaptive" ||
    selectedBox?.adaptive ||
    selectedBox?.isAdaptive;

  const getColClass = () => {
    if (isAdaptiveCase) return "col-md-6";

    return "col-md-4";
  };

  const handleSaveAssessment = async ({ isDraft = false } = {}) => {
    console.log("Saving...", { isDraft });

    // ❌ No questions
    if (!questions || questions.length === 0) {
      console.log("No questions");
      return;
    }

    // 🛑 NEW: Block Save as Draft if marks mismatch
    if (maxMarks > 0 && isMarksMismatch) {
      toast.error(
        marksDiff > 0
          ? `Total marks exceeded by ${marksDiff}. Please reduce to match ${maxMarks} marks.`
          : `${Math.abs(marksDiff)} mark(s) remaining. Please add more to reach ${maxMarks} marks.`,
      );
      return;
    }

    // ✅ Duplicate check (always)
    const hasDuplicate = findDuplicateQuestions();
    if (hasDuplicate) {
      console.log("Duplicate found ❌");
      console.log("viewErrorMsg", viewErrorMsg);
      console.log("isopenPopupDupli", isopenPopupDupli);
      return; // 🚫 stop
    }

    // ✅ Validation ONLY for publish
    const isValid = checkAllDataField();
    if (isValid) {
      setOpen(false);
      console.log("Validation failed ❌");
      return;
    }

    // ✅ Close drawer
    setOpen(false);

    // ✅ Call API
    handleCreateAssessment({ isDraft });
  };
  const handleSearch = (value) => {
    setSearchTerm(value);

    if (!value) {
      setActiveQuestion(null);
      return;
    }

    // ✅ 1. Search by Question Number
    const questionNumber = parseInt(value);

    if (!isNaN(questionNumber)) {
      const index = questionNumber - 1;

      if (questionRefs.current[index]) {
        scrollToQuestion(index); // 🔥 use new function
      }
      return;
    }

    // ✅ 2. Search by Title
    const lowerValue = value.toLowerCase();

    const foundIndex = questions.findIndex((q) =>
      q?.title?.toLowerCase().includes(lowerValue),
    );

    if (foundIndex !== -1) {
      scrollToQuestion(foundIndex); // 🔥 use new function
    }
  };

  const scrollToQuestion = (index) => {
    const element = questionRefs.current[index];
    const container = scrollContainerRef.current;

    if (!element || !container) return;

    const HEADER_OFFSET = 120;

    const elementTop = element.offsetTop;
    const scrollPosition = elementTop - HEADER_OFFSET;

    container.scrollTo({
      top: scrollPosition,
      behavior: "smooth",
    });

    setActiveQuestion(index);
  };

  return (
    <div className="row orange-scrollBar">
      <div className="col-12">
        <div
          className="w-100 fixed top-0 mt-1 d-flex justify-content-evenly align-items-center gap-1 border p-3"
          style={{
            background: "#fafafa",
            cursor: "pointer",
            overflowX: "auto",
            whiteSpace: "nowrap",
          }}
        >
          <div className="d-flex align-items-center gap-2  rounded-4 ">
            <div
              className="d-flex align-items-center gap-2 "
              style={{ cursor: "pointer" }}
            >
              {/* Back Icon */}
              <div
                className="d-flex align-items-center justify-content-center rounded-circle"
                style={{
                  width: "36px",
                  height: "36px",
                  backgroundColor: "#FFF1E6",
                  color: "#F28C28",
                  fontSize: "20px",
                  fontWeight: "600",
                  flexShrink: 0,
                }}
                onClick={() => navigate(-1)}
              >
                &lt;
              </div>

              {/* Title & Description Table-like Layout */}
              <div
                className="d-flex flex-column gap-2"
                style={{
                  maxWidth: "170px", // VERY IMPORTANT
                  minWidth: "170px",
                }}
              >
                <div>
                  <span
                    className="poppins-semibold"
                    style={{
                      display: "inline-block",
                      padding: "6px 14px",
                      fontSize: "13px",
                      fontWeight: 600,
                      borderRadius: "10px",
                      backgroundColor: "#e0f2fe",
                      color: "#075985",
                      letterSpacing: "0.3px",
                      border: "1px solid #bae6fd",
                    }}
                    onClick={() => navigate(-1)}
                  >
                    {componentType === ComponentType.ASSESSMENT && "Assessment"}
                    {componentType === ComponentType.HOMEWORK && "Homework"}
                    {componentType === ComponentType.QUESTION_BANK &&
                      "Question Bank"}
                  </span>
                </div>

                {/* Title Row */}
                <div className="d-flex align-items-start gap-2">
                  {/* LABEL */}
                  <span
                    style={{
                      minWidth: "30px", // FIXED label width
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "#F28C28",
                      flexShrink: 0, // IMPORTANT
                    }}
                  >
                    Title:
                  </span>

                  {/* VALUE */}
                  <span
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: "#1f2937",
                      flex: 1, // IMPORTANT
                      minWidth: 0, // IMPORTANT for ellipsis in flex
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={name}
                  >
                    {name}
                  </span>
                </div>

                {componentType === ComponentType.QUESTION_BANK && (
                  <button
                    disabled={!questions || questions.length === 0}
                    onClick={() => setOpen(true)}
                    className="rounded-3 px-4 py-2 poppins-semibold"
                    style={{
                      display: "inline-block", // 👈 parent se stretch nahi hoga
                      width: "auto", // ya "180px"
                      height: "40px", // 👈 khud ki height
                      backgroundColor: "#F28C28",
                      color: "#ffffff",
                      border: "none",
                      opacity: !questions || questions.length === 0 ? 0.6 : 1,
                      cursor:
                        !questions || questions.length === 0
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    Review & Finish
                  </button>
                )}

                {/* ─── NEW: Marks Status Badge ─── */}
                {componentType !== ComponentType.QUESTION_BANK &&
                  maxMarks > 0 && (
                    <Tooltip
                      title={
                        !isMarksMismatch
                          ? "Perfect! Total marks match the allotted marks"
                          : totalMarks > maxMarks
                            ? `Exceeded by ${marksDiff} mark(s). Please reduce.`
                            : `${Math.abs(marksDiff)} mark(s) remaining. Please add more.`
                      }
                      arrow
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "8px 14px",
                          borderRadius: "10px",
                          backgroundColor: !isMarksMismatch
                            ? "#dcfce7"
                            : totalMarks > maxMarks
                              ? "#fdecea"
                              : "#fef3c7",
                          border: `1.5px solid ${
                            !isMarksMismatch
                              ? "#86efac"
                              : totalMarks > maxMarks
                                ? "#f5c6c2"
                                : "#fcd34d"
                          }`,
                          cursor: "default",
                          flexShrink: 0,
                        }}
                      >
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: 600,
                            color: !isMarksMismatch
                              ? "#166534"
                              : totalMarks > maxMarks
                                ? "#b91c1c"
                                : "#92400e",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {!isMarksMismatch ? "✓ " : "⚠ "}
                          Marks: {totalMarks} / {maxMarks}
                        </span>
                        {isMarksMismatch && (
                          <span
                            style={{
                              fontSize: "11px",
                              fontWeight: 700,
                              padding: "2px 6px",
                              borderRadius: "6px",
                              backgroundColor:
                                totalMarks > maxMarks ? "#fecaca" : "#fde68a",
                              color:
                                totalMarks > maxMarks ? "#7f1d1d" : "#78350f",
                            }}
                          >
                            {totalMarks > maxMarks
                              ? `+${marksDiff}`
                              : `${marksDiff}`}
                          </span>
                        )}
                      </div>
                    </Tooltip>
                  )}
              </div>
            </div>
          </div>

          <div className=" row g-3">
            {/* SCHOOL LIBRARY */}
            <div className={getColClass()}>
              <LibraryButton
                title="School"
                subtitle="Library"
                img="/images/Picture1.png"
                onClick={() => {
                  setClick1(true);
                  setSourceLibrary(SourceLibrary.FROM_SCHOOL_LIBRARY);
                }}
              />
            </div>

            {/* B4S LIBRARY */}
            <div className={getColClass()}>
              <LibraryButton
                title="B4S"
                subtitle="Library"
                img="/images/Picture2.png"
                onClick={() => {
                  setClick1(true);
                  setSourceLibrary(SourceLibrary.FROM_B4S_LIBRARY);
                }}
              />
            </div>

            {componentType === ComponentType.QUESTION_BANK &&
              hasFeature("AI_QUERY") && (
                <div className={getColClass()}>
                  <LibraryButton
                    title="AI"
                    subtitle="Generator"
                    img="/images/add button.svg"
                    onClick={() => setOpenQuestionBox(true)}
                  />
                </div>
              )}

            {/* QUESTION FILE */}
            {!isAdaptiveCase && (
              <div
                className={
                  componentType === ComponentType.QUESTION_BANK &&
                  hasFeature("AI_QUERY")
                    ? "col-md-4  items-center d-flex justify-content-center"
                    : getColClass()
                }
              >
                <LibraryButton
                  title="Question"
                  subtitle="File"
                  img="/images/fileIconDocument.svg-removebg-preview.png"
                  onClick={() => setNewQuestionPaperMaper(true)}
                />
              </div>
            )}
          </div>
          {componentType !== ComponentType.QUESTION_BANK && (
            <button
              disabled={
                !questions ||
                questions.length === 0 ||
                (maxMarks > 0 && isMarksMismatch)
              }
              onClick={() => {
                if (maxMarks > 0 && isMarksMismatch) {
                  toast.error(
                    marksDiff > 0
                      ? `Total marks exceeded by ${marksDiff}. Please reduce to match ${maxMarks} marks.`
                      : `${Math.abs(marksDiff)} mark(s) remaining. Please add more to reach ${maxMarks} marks.`,
                  );
                  return;
                }
                setOpen(true);
              }}
              className="rounded-3 px-4 py-2 poppins-semibold"
              style={{
                display: "inline-block",
                width: "auto",
                height: "40px",
                backgroundColor: "#F28C28",
                color: "#ffffff",
                border: "none",
                opacity:
                  !questions ||
                  questions.length === 0 ||
                  (maxMarks > 0 && isMarksMismatch)
                    ? 0.6
                    : 1,
                cursor:
                  !questions ||
                  questions.length === 0 ||
                  (maxMarks > 0 && isMarksMismatch)
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              Review & Finish
            </button>
          )}
        </div>
        <div className="search-container">
          <input
            type="search"
            placeholder="Search by Question No. or Title"
            className="search-input"
            value={searchTerm}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
        <div
          ref={scrollContainerRef}
          className="hw_question_container orange-scrollBar"
          style={{
            height: `${
              componentType === ComponentType.HOMEWORK ||
              componentType === ComponentType.QUESTION_BANK
                ? "350px"
                : "450px"
            } `,
            overflow: "auto",
            paddingBottom: "10px",
          }}
        >
          {questions &&
            questions?.length > 0 &&
            questions?.map((question, index) => (
              <div
                key={index}
                ref={(el) => (questionRefs.current[index] = el)}
                className="mb-4 question-item"
              >
                <DefaultQuestion
                  key={index}
                  nextQuestion={index}
                  question={question}
                  setQuestions={setQuestions}
                  assessmentDetails={assessmentDetails}
                  componentType={componentType}
                  qArr={questions}
                  showErrorInputField={showErrorInputField}
                  setShowErrorInputField={setShowErrorInputField}
                  getErrorMsg={getErrorMsg}
                  isChecked={isChecked}
                  selectedBox={selectedBox} // 👈 YEH PEHLE SE THA
                  isActive={activeQuestion === index}
                  chapter={chapters}
                  questionType={questionType}
                  // 🔥 YEH ADD KARO (Edit mode mein bhi AI UI enable karne ke liye)
                  hasDescriptiveAutoAssessment={true}
                  onToggle={() =>
                    setActiveQuestion(activeQuestion === index ? null : index)
                  }
                />
              </div>
            ))}

          <div className="d-flex align-items-center justify-content-center mt-3">
            {/* 🔶 OUTER BORDER (single unit) */}
            <div
              className="d-flex flex-column gap-2 px-4 py-3 rounded-4"
              style={{
                border: "2px solid #F28C28",
                background: "#FFF7ED",
                width: "fit-content",
                minWidth: "260px",
              }}
            >
              {/* ☑️ Copy settings row (ONLY when questions exist) */}
              {questions && questions.length > 0 && (
                <>
                  <div className="d-flex align-items-center justify-content-center gap-2">
                    <input
                      type="checkbox"
                      checked={copyPrevSettings}
                      onChange={(e) => setCopyPrevSettings(e.target.checked)}
                      style={{
                        accentColor: "#F28C28",
                        width: "16px",
                        height: "16px",
                        cursor: "pointer",
                      }}
                    />

                    <span
                      className="poppins-semibold"
                      title="Copies book, chapter, skill, difficulty, question type & marks from the previous question"
                      style={{ color: "#8D4B28", fontSize: "14px" }}
                    >
                      Copy Previous settings
                    </span>
                  </div>

                  {/* 🔸 divider only when checkbox visible */}
                  <div
                    style={{
                      width: "100%",
                      height: "1px",
                      backgroundColor: "#F28C28",
                      opacity: 0.3,
                    }}
                  />
                </>
              )}

              {/* ➕ Add Question button (ALWAYS visible) */}
              <button
                id="Add-options-btn"
                type="button"
                onClick={addMoreQuestion}
                className="d-flex align-items-center justify-content-center gap-2 px-3 py-1 rounded-3 poppins-semibold"
                style={{
                  border: "2px solid #8D4B28",
                  color: "#8D4B28",
                  backgroundColor: "#fff",
                  fontSize: "14px",
                }}
              >
                <img src="/images/add button.svg" alt="" />
                Add question
              </button>
            </div>
          </div>
        </div>
      </div>

      {componentType !== ComponentType.QUESTION_BANK && click && (
        <QuestionListAssessment
          questions={questions}
          setQuestions={setQuestions}
          assessmentDetails={assessmentDetails}
          setAssessmentDetails={setAssessmentDetails}
          change={setClick}
          total_marks={findTotalMarks()}
          name={name}
          sourceLibrary={sourceLibrary}
          componentType={componentType}
          operationType={OperationType.UPDATE}
          isChecked={isChecked}
          selectedBox={selectedBox}
        />
      )}

      {click1 && (
        <SelectFromLibr
          setClick1={setClick1}
          setQuestions={setQuestions}
          assessmentDetails={assessmentDetails}
          questions={questions}
          sourceLibrary={sourceLibrary}
          componentType={componentType}
          getquestiondata={getquestiondata}
          operationType={operationType}
          selectedBox={selectedBox}
        />
      )}
      {componentType === ComponentType.QUESTION_BANK && click && (
        <PublishPreviewQB
          setPreview={setClick}
          displayQuestions={questions}
          details={assessmentDetails}
          selectedBox={selectedBox}
          hasDescriptiveAutoAssessment={true}
        />
      )}

      {isloading && (
        <div className="publish_transprant_body1">
          {isloading && (
            <div className=" p-4 publish_white_containerPre d-flex justify-content-center align-items-center">
              <img className="" width="150" src="/gif/LoaderDot.gif" alt="" />
            </div>
          )}
        </div>
      )}

      {isopenPopupDupli && (
        <CheckDuplicatePop
          isOpen={isopenPopupDupli}
          message={viewErrorMsg}
          onClose={() => isSetOpenPopupDupli(false)}
        />
      )}

      <RightDrawer open={open} onClose={() => setOpen(false)}>
        {/* <h2>Question Details</h2> */}
        <div className=" ">
          <div
            className="border rounded p-3 orange-scrollbar"
            style={{
              borderColor: "#e0e0e0",
              borderRadius: "12px",
              boxShadow: "0px 1px 3px rgba(0,0,0,0.1)",
              width: "96%",
            }}
          >
            {/* Row 1: Subject + Total Marks */}
            <div className="d-flex align-items-center justify-content-between mb-2 poppins-semibold">
              <div>
                <span style={{ color: "#8D4B28" }}>Subject :</span>{" "}
                <span
                  style={{ fontWeight: "bold", color: "#000" }}
                  title={subject_id?.name}
                >
                  {shortenParagraph(subject_id?.name, 30)}
                </span>
              </div>

              {/* ─── NEW: Color-coded Total Marks ─── */}
              <div
                className="d-flex flex-column align-items-end"
                style={{ gap: 4 }}
              >
                <div>
                  <span style={{ color: "#8D4B28" }}>Total Marks :</span>{" "}
                  <span
                    style={{
                      fontWeight: "bold",
                      color: isMarksMismatch
                        ? totalMarks > maxMarks
                          ? "#b91c1c"
                          : "#d97706"
                        : maxMarks > 0
                          ? "#16a34a"
                          : "#000",
                    }}
                  >
                    {totalMarks}
                    {maxMarks > 0 ? ` / ${maxMarks}` : ""}
                  </span>
                </div>
                {maxMarks > 0 && isMarksMismatch && (
                  <span
                    style={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: totalMarks > maxMarks ? "#b91c1c" : "#d97706",
                    }}
                  >
                    {totalMarks > maxMarks
                      ? `Exceeded by ${marksDiff}`
                      : `${Math.abs(marksDiff)} mark(s) remaining`}
                  </span>
                )}
              </div>
            </div>

            {/* Row 2: Total Questions */}
            <div className="poppins-semibold d-flex align-items-center justify-content-center gap-1">
              <span style={{ color: "#8D4B28" }}>Total Questions :</span>{" "}
              <span style={{ fontWeight: "bold", color: "#000" }}>
                {" "}
                {questions?.length}
              </span>
            </div>
          </div>

          <div className="needfulinfo w-100 d-flex flex-column align-item-start p-2 ">
            <div className="skills d-flex align-item-center justify-content-center border border-2 rounded-3 p-2">
              <div className="needfulimg" style={{ width: "60%" }}>
                <img
                  src="/images/needfulimg.png"
                  alt="needfulimg"
                  style={{ width: "100%", marginRight: "12px" }}
                ></img>
              </div>
              <div className="textpart" style={{ width: "40%" }}>
                <h5 className="needful_heading">Skills</h5>
                {questionScoreCounter.skills?.map((curr, index) => {
                  return (
                    <div className="sktext d-flex justify-content-between">
                      {" "}
                      <span>{curr.label + " : "}</span>{" "}
                      <span className="ms-3">{curr.value}</span>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className=" w-100">
              <div
                className="w-100 my-2 difficulty_level border border-2 rounded-3"
                style={{ padding: "6px 15px" }}
              >
                <h5
                  className="d-flex justify-content-center align-items-center gap-2 poppins-semibold"
                  style={{
                    fontSize: "15px",
                    fontWeight: 600,
                    color: "#1f2937",
                    letterSpacing: "0.4px",
                    marginBottom: "8px",
                  }}
                >
                  <span
                    style={{
                      width: "20px",
                      height: "2px",
                      backgroundColor: "#F28C28",
                      borderRadius: "2px",
                    }}
                  />
                  Difficulty Level
                  <span
                    style={{
                      width: "20px",
                      height: "2px",
                      backgroundColor: "#F28C28",
                      borderRadius: "2px",
                    }}
                  />
                </h5>

                <ProgressBar
                  progressItemsData={questionScoreCounter.difficultyLevel}
                />
              </div>
              <div
                className="w-100 ques_type border border-2 rounded-3"
                style={{ padding: "6px 15px" }}
              >
                <h5
                  className="d-flex justify-content-center align-items-center gap-2 poppins-semibold"
                  style={{
                    fontSize: "15px",
                    fontWeight: 600,
                    color: "#1f2937",
                    letterSpacing: "0.4px",
                    marginBottom: "8px",
                  }}
                >
                  <span
                    style={{
                      width: "20px",
                      height: "2px",
                      backgroundColor: "#F28C28",
                      borderRadius: "2px",
                    }}
                  />
                  Question Type
                  <span
                    style={{
                      width: "20px",
                      height: "2px",
                      backgroundColor: "#F28C28",
                      borderRadius: "2px",
                    }}
                  />
                </h5>

                <ProgressBar
                  progressItemsData={questionScoreCounter.questionType}
                />
              </div>
            </div>
          </div>
          <div className=" me-2 d-grid gap-2 d-md-flex justify-content-center align-items-center ">
            {componentType !== ComponentType.QUESTION_BANK && (
              <button
                onClick={() => handleSaveAssessment({ isDraft: true })}
                disabled={!questions || questions.length === 0}
                style={{
                  border: "3px solid #8D4B28",
                  color: "#8D4B28",
                  backgroundColor: "white",
                }}
                className="rounded-3 px-3 py-1 d-flex align-items-center justify-content-center poppins-semibold"
              >
                Save as Draft
              </button>
            )}

            <button
              className="btn  next_button"
              disabled={!questions || questions.length === 0}
              onClick={() => {
                // 🛑 Block Next if marks mismatch
                if (maxMarks > 0 && isMarksMismatch) {
                  toast.error(
                    marksDiff > 0
                      ? `Total marks exceeded by ${marksDiff}. Please reduce to match ${maxMarks} marks.`
                      : `${Math.abs(marksDiff)} mark(s) remaining. Please add more to reach ${maxMarks} marks.`,
                  );
                  return;
                }
                const isCheckAllValid = checkAllDataField();

                findDuplicateQuestions();
                if (typeof handleAdaptiveQuesType === "function") {
                  handleAdaptiveQuesType();
                }
                if (isCheckAllValid || hidePopupCheck) {
                  setClick(false);
                  setOpen(false);
                } else {
                  setClick(true);
                  setOpen(false);
                }
              }}
            >
              Next
            </button>
          </div>
        </div>
      </RightDrawer>

      {openQuestionBox && (
        <AiGenerateQuestions
          setClick1={setClick1}
          setOpenQuestionBox={setOpenQuestionBox}
          setQuestions={setQuestions}
          assessmentDetails={assessmentDetails}
          questions={questions}
          sourceLibrary={SourceLibrary.FROM_AI_LIBRARY}
          componentType={componentType}
          getquestiondata={getquestiondata}
        />
      )}

      {newQuestionPaperMaper && (
        <>
          <div
            className="position-fixed top-0 start-0 w-100 h-100"
            style={{
              background: "rgba(0,0,0,0.3)",
              zIndex: 9998,
            }}
          />

          <QuestionPaperMapper
            onClose={() => setNewQuestionPaperMaper(false)}
            selectedBox={selectedBox}
            componentType={componentType}
            onSaveSubmit={(mapperData) => {
              handleMapperSave(mapperData);
              setNewQuestionPaperMaper(false);
            }}
          />
        </>
      )}
    </div>
  );
};

export default UpdateQuestions;

export const LibraryButton = ({ title, subtitle, img, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="btn d-flex align-items-center gap-3 px-4 py-3 w-100"
      style={{
        backgroundColor: "#fee3b8",
        borderRadius: "0.9rem",
        border: "none",
      }}
    >
      {/* ➕ PLUS ICON */}
      <AddCircleOutlineIcon sx={{ fontSize: 34, color: "#b45309" }} />

      {/* 📝 TEXT */}
      <div className="d-flex flex-column flex-grow-1 text-start">
        <span className="poppins-semibold" style={{ fontSize: "18px" }}>
          {title}
        </span>
        <span className="text-muted" style={{ fontSize: "13px" }}>
          {subtitle}
        </span>
      </div>

      {/* 📦 IMAGE ICON */}
      <img src={img} alt="" width={36} />
    </button>
  );
};
